import Box from '@mui/material/Box';
import React, { useEffect, useState } from 'react';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import NotifyMessagePage from '../../ui-parts/NotifyMessagePage';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/**
 * TermsOfUse Page Component
 */
const TermsOfUse = (props) => {
  const screenId = 'MyM904';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [termsOfUseText, setTermsOfUseText] = useState([]);
  const isPc = useMediaQuery(mediaQuery.pc);

  // ページロード時処理
  useEffect(() => {
    // 正常終了時コールバック
    const callbackResultContext = (result) => {
      setTermsOfUseText(result);
    }
    apiRequest.requestJson('api/terms-of-use/load', 'GET', callbackResultContext)
  }, []);

  return (
    <NotifyMessagePage >
      <Box className='w-100 text-start' >
        <Box sx={{ float: isPc ? 'right':'none' }} >
          <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgLogo} width='250px' height='100px' />
        </Box>
        {termsOfUseText.map((item, index) =>
          item.TextType === constants.TermsTextType.Title
            ? <MyMVariantLabel key={index} className='mb-2 fw-bold' variant='h4'>{item.ParagraphText}</MyMVariantLabel>
        : item.TextType === constants.TermsTextType.Header
            ? <MyMVariantLabel key={index} className='mb-2 fw-bold' variant='h6'>{item.ParagraphText}</MyMVariantLabel>
        : item.TextType === constants.TermsTextType.Text
            ? <MyMLabel key={index} className='mb-2'>{item.ParagraphText}</MyMLabel>
        : <></>
        )}
      </Box>
    </NotifyMessagePage>
  );
}
export default TermsOfUse;
